import avaDefault from 'assets/images/ava-default.jpeg'
import {
	HeaderAccountGifthistSVG,
	HeaderAccountLogoutSVG,
	HeaderAccountMyaccountSVG,
	HeaderAccountSettingSVG,
} from 'assets/svg/HeaderSVG'
import { CancelSVG } from 'assets/svg/ProfileSVG/CancelSVG'
import CancelProfileModal from 'components/Modal/CancelProfileModal'
import ConfirmModal from 'components/Modal/ConfirmModal'
import { PATHS } from 'config/routes'
import { getUserInfoQuery, useCheckSub } from 'dataLayer/game'
import { queryKeyUserInfo } from 'dataLayer/user'
import { useEffect, useState } from 'react'
import { Button, Col, Container, Nav, Row, Spinner, Tab } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useQuery, useQueryClient } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { setProfilePage } from 'store/actions'
import { curState } from 'store/selector'
import { destroyUser, removeModal } from 'utils/localStorage'
import { makeData } from 'utils/makeData'
import GiftHist from './components/GiftHist'
import Invitation from './components/Invitation'
import SelectAva from './components/SelectAva'
import Setting from './components/Setting'
import UserInfo from './components/UserInfo'

function ProfilePage() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const selector = useSelector(curState)
	const [modalCancel, setModalCancel] = useState(false)
	const [modalConfirm, setModalConfirm] = useState(false)
	const queryClient = useQueryClient()
	const [selectAva, setSelectAva] = useState(false)
	// useEffect(() => { }, [t('profile.sidebar.gift_hist')])
	const { data: userInfo, isLoading } = useQuery(getUserInfoQuery())
	const [profileActiveTab, setProfileActiveTab] = useState(1)
	const defaultAva = makeData('image', 15)
	const [dataCheckSub, setDataCheckSub] = useState()
	// const invitation = makeData('invitation', 17)

	function handleSelectAva() {
		setSelectAva(prev => !prev)
	}
	function handleCloseSelectAva() {
		setSelectAva(false)
	}
	function openCancelModal() {
		setModalCancel(!modalCancel)
	}
	function openConfirmModal() {
		setModalConfirm(true)
	}
	function closeConfirmModal() {
		setModalConfirm(false)
	}

	function handleLogout() {
		destroyUser()
		removeModal()
		closeConfirmModal()
		queryClient.invalidateQueries(queryKeyUserInfo)
		navigate(PATHS.HOME_PAGE)
	}

	const { mutate } = useCheckSub(data => {
		if (data?.responseCode === '200') {
			setDataCheckSub(data?.data)
		}
	})

	useEffect(() => {
		mutate({ location: 'HOME', from: '' })
	}, [])

	const handleYes = () => {
		window.location.href = dataCheckSub?.urlWebView ?? ''
	}

	return (
		<>
			<Container fluid className="profilepage-container">
				<Tab.Container
					id="left-tabs-example"
					activeKey={selector.profileTab}
					onSelect={k => dispatch(setProfilePage(k))}
				>
					<Row>
						<Col sm={4} className="profilepage-sidebar">
							<Row className="profilepage-sidebar__info">
								<div className="ava-frame">
									<img
										src={userInfo?.avatarImage ?? avaDefault}
										onError={e => {
											e.target.onerror = null
											e.target.src = avaDefault
										}}
										alt="User's avatar"
									/>
									{/* <div className="upload-ava">
										<img
											src={uploadAvaIcon}
											onClick={handleSelectAva}
											alt="Upload user's avatar"
										/>
									</div> */}
								</div>
								<p>{userInfo?.displayName}</p>
							</Row>
							<Row className="profilepage-sidebar__menu mt-3 flex-column">
								<Nav variant="pills" className="flex-column">
									<Nav.Item onClick={handleCloseSelectAva}>
										<Nav.Link eventKey={1}>
											<HeaderAccountMyaccountSVG
												width="20"
												height="20"
												viewBox="0 0 19 19"
											/>
											{t('profile.sidebar.my_acc')}
										</Nav.Link>
									</Nav.Item>
									<Nav.Item onClick={handleCloseSelectAva}>
										<Nav.Link eventKey={2}>
											<HeaderAccountGifthistSVG
												width="20"
												height="20"
												viewBox="0 0 19 19"
											/>
											{t('profile.sidebar.gift_hist')}
										</Nav.Link>
									</Nav.Item>
									{/* <Nav.Item onClick={handleCloseSelectAva}>
										<Nav.Link eventKey={3}>
											<HeaderAccountInvitationSVG
												width="20"
												height="20"
												viewBox="0 0 19 19"
											/>
											{t('profile.sidebar.invitation')}{' '} */}
									{/* {invitation.length < 10
												? `(0${invitation.length})`
												: `(${invitation.length})`} */}
									{/* </Nav.Link>
									</Nav.Item> */}
									{/* <Nav.Item onClick={handleCloseSelectAva}>
										<Nav.Link eventKey={4}>
											<ProfileIntroduceSVG
												width="20"
												height="20"
												viewBox="0 0 25 22"
											/>
											{t('profile.sidebar.introduce')}
										</Nav.Link>
									</Nav.Item> */}
									<Nav.Item onClick={handleCloseSelectAva}>
										<Nav.Link eventKey={5}>
											<HeaderAccountSettingSVG
												width="20"
												height="20"
												viewBox="0 0 19 19"
											/>
											{t('profile.sidebar.setting')}
										</Nav.Link>
									</Nav.Item>
									{/* <Nav.Item onClick={handleCloseSelectAva}>
										<Nav.Link eventKey={6}>
											<ProfileChangepassSVG
												width="20"
												height="20"
												viewBox="0 0 25 25"
											/>
											{t('profile.sidebar.change_pass')}
										</Nav.Link>
									</Nav.Item> */}
									{dataCheckSub?.isSub && (
										<Button variant="dark" onClick={openCancelModal}>
											<CancelSVG width="20" height="20" viewBox="0 0 24 24" />
											{t('profile.sidebar.cancel')}
										</Button>
									)}
									<Button variant="dark" onClick={openConfirmModal}>
										<HeaderAccountLogoutSVG
											width="20"
											height="20"
											viewBox="0 0 19 19"
										/>
										{t('profile.sidebar.logout')}
									</Button>
								</Nav>
							</Row>
						</Col>
						<Col sm={8}>
							{selectAva ? (
								<div className="profilepage-content ms-2 ms-lg-4">
									<SelectAva defaultAva={defaultAva} />
								</div>
							) : (
								<Tab.Content className="profilepage-content ms-2 ms-lg-4">
									<Tab.Pane
										eventKey={1}
										className={`${isLoading ? 'text-center' : ''}`}
									>
										{isLoading ? (
											<Spinner animation="border" role="status"></Spinner>
										) : (
											<UserInfo userData={userInfo} />
										)}
									</Tab.Pane>
									<Tab.Pane eventKey={2}>
										<GiftHist />
									</Tab.Pane>
									<Tab.Pane eventKey={3}>
										<Invitation />
									</Tab.Pane>
									{/* <Tab.Pane eventKey={4}>
										<Introduce />
									</Tab.Pane> */}
									<Tab.Pane eventKey={5}>
										<Setting />
									</Tab.Pane>
									{/* <Tab.Pane eventKey={6}>
										<ChangePass />
									</Tab.Pane> */}
								</Tab.Content>
							)}
						</Col>
					</Row>
				</Tab.Container>
			</Container>
			<ConfirmModal
				show={modalConfirm}
				onHide={closeConfirmModal}
				title={t('modal.profile.logout')}
				onLogout={handleLogout}
			/>
			<CancelProfileModal
				show={modalCancel}
				onHide={openCancelModal}
				title={t('modal.profile.cancel')}
				onClick={handleYes}
			/>
		</>
	)
}

export default ProfilePage
